"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { UserControllerApiFactory } from "@/apis/user-management";
import SidebarBackground from "@/assets/images/sideback.png";
import TenantSelect from "@/components/Selects/TenantSelect";
import { LocalStorageKeys } from "@/constants/localStorage";
import { useAppStore } from "@/context/app-context";
import useApi from "@/hooks/useApi";
import useZoomLevel from "@/hooks/useZoomLevel";
import { getUser } from "@/utils/storage";
import { Content, Layout, Sidebar } from "@atom/ui-kit";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Outlet, useNavigate } from "react-router-dom";
import { getMenu } from "./AppLayout.utils";
import "./assets/sprite-flags-24x24.css";
import Logo from "./assets/wiselogo.svg";
import LogoCollapsed from "./assets/wiselogo_collapsed.svg";
import AppFooter from "./components/AppFooter";
import AppHeader from "./components/Appheader";
import BreadCrumb from "./components/BreadCrumb";
export var AppLayout = function () {
    var _a = useState(localStorage.getItem(LocalStorageKeys.SIDEBAR_COLLAPSED) === "true"), collapsed = _a[0], setCollapsed = _a[1];
    var _b = useTranslation(), t = _b.t, i18n = _b.i18n;
    var lang = localStorage.getItem("language") || "en";
    var navigate = useNavigate();
    var user = getUser();
    var _c = useAppStore(), state = _c[0], dispatch = _c[1];
    useZoomLevel();
    var _d = useApi({
        asyncFunction: UserControllerApiFactory().backofficeusersByTenantUsernameGet,
        errorCallback: function (error) {
            navigate("/sign-in");
        },
    }), call = _d.call, data = _d.data;
    var menu = useMemo(function () { return getMenu(t, data); }, [t, data]);
    useEffect(function () {
        if (lang) {
            i18n.changeLanguage(lang);
        }
    }, [i18n]);
    useEffect(function () {
        var tenant = localStorage.getItem(LocalStorageKeys.TENANT);
        call({
            username: user.username,
            tenant: tenant || "",
        });
    }, []);
    useEffect(function () {
        localStorage.setItem(LocalStorageKeys.SIDEBAR_COLLAPSED, collapsed.toString());
    }, [collapsed]);
    return (_jsxs(Layout, { children: [_jsx(Sidebar, { sidebarBackground: "url(".concat(SidebarBackground, ")"), collapsed: collapsed, items: menu, logo: _jsx("img", { width: collapsed ? 45 : 150, src: collapsed ? LogoCollapsed : Logo, alt: "Logo" }), onCollapse: setCollapsed, footer: _jsx(AppFooter, {}), extraInfo: _jsx("div", { style: {
                        padding: "10px",
                    }, children: _jsx(TenantSelect, { isTransparent: true, style: { width: "100%" }, value: localStorage.getItem(LocalStorageKeys.TENANT), onChange: function (value) {
                            dispatch({ type: "SET_TENANT", payload: value });
                            localStorage.setItem(LocalStorageKeys.TENANT, value);
                            window.location.reload();
                        } }) }) }), _jsxs(Layout, { children: [_jsx(AppHeader, { collapsed: collapsed, setCollapsed: setCollapsed, lang: lang, menu: menu }), _jsxs(Content, { style: { padding: 20, height: "calc(100% - 50px)" }, children: [_jsx(BreadCrumb, {}), _jsx(Outlet, {})] })] })] }));
};
export default AppLayout;
